import moment from 'moment'

import { computeShiftDates } from '../../../utils'

export const getShiftIsLate = (shift, shiftTimeRange) => {
  if (!shift) {
    return false
  }

  const plannedShiftStartTime = moment(shift.starts_at)
  const plannedShiftEndTime = moment(shift.ends_at)

  const { startDate, endDate } = computeShiftDates(
    shiftTimeRange,
    moment(shift.starts_at)
  )

  // In case shifts overlaps at night and employee
  // come after midnight, we compare and add one day
  if (
    startDate.hours() < plannedShiftStartTime.hour() &&
    plannedShiftEndTime.date() > plannedShiftStartTime.date() &&
    startDate.hours() < endDate.hour()
  ) {
    startDate.add(1, 'd')
  }

  return moment(startDate).isAfter(plannedShiftStartTime)
}
